import Repository from "../../repository";

export default {
    Add: (payload) => Repository.post(`/api/Carts/Add`, payload),
    Edit: (payload) => Repository.post(`/api/Carts/Edit`, payload),
    ApplyVoucher: (payload) => Repository.post(`/api/Carts/ApplyVoucher`, payload),
    GetDetail: (payload) => Repository.post(`/api/Carts/GetDetail`, payload),
    Delete: (payload) => Repository.post(`/api/Carts/Delete`, payload),
}
